import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';
import 'photoswipe/dist/photoswipe.css';

const options = {
    gallery: '.gallery-row',
    children: '.pic a',
    mainClass: 'pswp--custom',
    bgOpacity: 0.8,
    // arrowPrevSVG: '<i class="ic ic-angle-left"></i>',
    // arrowNextSVG: '<i class="ic ic-angle-right"></i>',
    pswpModule: PhotoSwipe
};
const lightbox = new PhotoSwipeLightbox(options);
lightbox.on('contentLoad', (e) => {
    const { content, isLazy } = e;
    // console.log('contentLoad', content)
    if (content.data.element.getAttribute('title')) {
        e.preventDefault();

        content.element = document.createElement('img');
        content.element.src = content.data.src;
        content.element.setAttribute('alt', '');
        content.element.className = 'pswp__img';

        content.pictureElement = document.createElement('div');
        content.pictureElement.className = 'pswp__custom-container';
        // content.pictureElement.innerHTML = content.data.element.getAttribute('title');
        const html = createElementFromHTML('<div class="pswp__custom-caption">'+content.data.element.getAttribute('title')+'</div>');
        content.pictureElement.appendChild(html);

        content.state = 'loading';

        if (content.element.complete) {
            content.onLoaded();
        } else {
            content.element.onload = () => {
                content.onLoaded();
            };

            content.element.onerror = () => {
                content.onError();
            };
        }
    }
});
lightbox.on('contentAppend', (e) => {
    const { content } = e;
    // console.log('contentAppend', content)
    if (content.pictureElement && !content.pictureElement.parentNode) {
        e.preventDefault();
        content.pictureElement.insertBefore(content.element, content.pictureElement.firstChild);
        content.slide.container.appendChild(content.pictureElement);
        content.slide.container.classList.add('show');
    }
});
lightbox.on('contentRemove', (e) => {
    const { content } = e;
    // console.log('contentRemove', content)
    if (content.pictureElement && content.pictureElement.parentNode) {
        e.preventDefault();
        content.pictureElement.remove();
    }
});
lightbox.init();
function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes.
    return div.firstChild;
}
